import {useMutation, UseMutationResult} from "@tanstack/react-query";
import configAxios from "../configuration/configAxios";
import {errorHandlerServices} from "../configuration/errorHandle";
import {UserDepartmentInterface} from "../interface/UserDepartmentInterface";

interface FindProps {
    idUser: string
}

export const findPermissionsDepartment = async (data: FindProps) => {
    return await configAxios.get(`/ms-menus/departments/findDepartmentsPermissionByUser?idUser=${data.idUser}`).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return response.data.object
        }
    }).catch(error => {
        errorHandlerServices(error, true)
        throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/departments/findPermissionsDepartment`);
    })
}

export const useFindPermissionsDepartment = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: FindProps) => findPermissionsDepartment(data),
    });
}

export const assignDepartment = async (data: UserDepartmentInterface) => {
    return await configAxios.post(`/ms-menus/departments/assignDepartment`, data).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return response.data.object
        }
    }).catch(error => {
        errorHandlerServices(error, true)
        throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/departments/assignDepartment`);
    })
}

export const useAssignDepartment = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: UserDepartmentInterface) => assignDepartment(data),
    });
}
